var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataGrid',{attrs:{"data-retriever":_vm.getData,"fields":_vm.fields}})}
var staticRenderFns = []

export { render, staticRenderFns }